export enum AppActionTypes {
  ACTION_TOGGLE_SIDEBAR = 'ACTION_TOGGLE_SIDEBAR',
  ACTION_CLOSE_SIDEBAR = 'ACTION_CLOSE_SIDEBAR',
  ACTION_TOGGLE_DEVICE = 'ACTION_TOGGLE_DEVICE',
  ACTION_SET_LANGUAGE = 'ACTION_SET_LANGUAGE',
  ACTION_SET_SIZE = 'ACTION_SET_SIZE',
}
